var map = {
	"./Auth.vue": "./resources/js/base/layouts/Auth.vue",
	"./Default.vue": "./resources/js/base/layouts/Default.vue",
	"./Empty.vue": "./resources/js/base/layouts/Empty.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js/base/layouts sync .*\\.vue$";